import {
	COUPON_FETCH_SUCCESS,
} from "../actions/types";

const INIT_STATE = {
	coupon: {},
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case COUPON_FETCH_SUCCESS: {
			return {
				...state,
				coupon: action.payload
			};
		}
		default:
			return state;
	}
};
